export class WithLogger {
  constructor(logger, extraParams) {
    if (extraParams === void 0) {
      extraParams = {};
    }
    this.logger = logger;
    this.extraParams = extraParams;
  }
  logInfo(method, message, params) {
    if (params === void 0) {
      params = {};
    }
    this.logger.info(`${this.getServiceNameForLogs()}::${method} - ${message}`, this.getLogParams(params));
  }
  logWarn(method, message, params) {
    if (params === void 0) {
      params = {};
    }
    this.logger.warn(`${this.getServiceNameForLogs()}::${method} - ${message}`, this.getLogParams(params));
  }
  logError(method, message, params, error) {
    if (params === void 0) {
      params = {};
    }
    this.logger.error(`${this.getServiceNameForLogs()}::${method} - ${message}`, this.getLogParams(params, error), error);
  }
  logDebug(method, message, params) {
    if (params === void 0) {
      params = {};
    }
    this.logger.info(`DEBUG::${this.getServiceNameForLogs()}::${method} - ${message}`, this.getLogParams(params));
  }
  getLogParams(args, errorObject) {
    const params = {
      ...args
    };
    if (errorObject instanceof Error) {
      params.error = {
        name: errorObject.name,
        message: errorObject.message,
        stack: errorObject.stack,
        cause: errorObject.cause
      };
    }
    return {
      ...params,
      ...this.extraParams
    };
  }
}
//# sourceMappingURL=WithLogger.js.map